// extracted by mini-css-extract-plugin
export default {"navWrapper":"MobileNavigation_navWrapper__wzTC2","nav":"MobileNavigation_nav__SWjwZ"};